import {
  clearUserToken,
  getAccessToken,
  getSubId,
  isValidAccessToken,
  setAccessToken,
} from '@devhacker/shared/features/auth/utils/token';
import { refreshTokenSingleFlight } from '@devhacker/shared/features/auth/utils/refreshSingleFlight';
import { isRefreshConflict } from '@devhacker/shared/features/auth/utils/crossTabRefresh';
import { errorHandler } from './errorHandlerAuth';
import { useUserStore } from '~/features/user/store';
import { useUserService } from '~/features/user/service';
import { useAuthService } from '~/features/auth/service';

export async function requestInterceptors(config: any, moduleName?: string) {
  if (import.meta.server) return;

  const accessToken = getAccessToken();

  if (accessToken && !isValidAccessToken(accessToken)) {
    try {
      const result = await refreshTokenSingleFlight();

      if (result.access_token) {
        setAccessToken(result.access_token);

        const subId = getSubId(result.access_token);
        const userStore = useUserStore();

        if (subId && userStore.userData) {
          await useUserService().fetchAndUpdateUser(subId);
        }
      } else {
        clearUserToken();
        useUserService().clearUser();
      }
    } catch (error) {
      if (isRefreshConflict(error)) {
        console.warn('Interceptor: access token refresh conflict, request aborted, session kept');
        throw error;
      }

      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status === 401 || status === 403) {
        useAuthService().clearSessionLocally();
      } else {
        errorHandler(error, moduleName);
      }
    }
  }

  const accessTokenActual = getAccessToken();
  if (accessTokenActual) {
    config.options.headers.set('Authorization', `Bearer ${accessTokenActual}`);
  }
}
